package es.subastia.data.model

import kotlinx.serialization.Serializable

@Serializable
data class SavedSearchDataModel(
    val id: String = "",
    val userId: String = "",
    val title: String? = null,
    val type: String? = null,
    val procedureType: String? = null,
    val province: String? = null,
    val query: String? = null,
    val createdAt: Double = 0.0
)
